@use "variables" as *;

.mainContainer {
  width: 100%;
  height: 100%;
  display: flex;
}

.mainDiv {
  display: flex;
  flex-grow: 1;
}

.section {
  margin-right: $spacing-s;
  margin-bottom: $spacing-m;
}

.sectionMobile {
  margin-bottom: $spacing-m;
}

.itemDiv {
  width: 100%;
  height: 36px;
  margin: $spacing-m;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.switchListItem {
  padding-left: $spacing-xl !important;
  padding-right: $spacing-xl !important;
}

.loadingDiv {
  width: 50px;
  padding-left: $spacing-m;
}

.graphsDiv {
  padding: $spacing-m $spacing-m $spacing-m $spacing-s;
  overflow: auto !important;
}

.graphsDivMobile {
  padding-top: $spacing-m;
  padding-bottom: $spacing-m;
  padding-right: $spacing-m;
  overflow: auto !important;
}

.detailMobile {
  padding-left: $spacing-m;
}

.resizeHandle {
  width: $spacing-m;
  display: flex;
  justify-content: center;
  outline: none !important;
}

.list {
  flex-grow: 1;
  padding: $spacing-m 0 0 $spacing-m;
  overflow: auto;
}

.dropzone {
  width: 100%;
  height: 100%;
}

.avatarContainer {
  display: flex;
  width: 100%;
  justify-content: center;
}

.avatar {
  width: 80px !important;
  height: 80px !important;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.publicCollectionsTitle {
  margin-top: $spacing-m;
  margin-bottom: $spacing-m;
}

.publicCollectionsCard {
  padding: $spacing-s;
}

.limitsCard {
  margin-bottom: $spacing-xxl;
}
